<template>
  <div class="pt-5 pl-md-5 mb-10" style="max-width: 1000px">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-container v-if="!loading">
      <v-alert
        elevation="1"
        type="info"
        v-if="list._id && list.status == 'requested'"
        border="top"
        colored-border
      >
        <div class="mb-2">
          {{ $t("Cmsg28") }}
          <a @click="inquireVerification()">{{ $t("Cmsg280") }}</a>
        </div>
      </v-alert>
      <v-alert type="success" v-if="list._id && list.user_id.isIdVerified">
        {{ $t("Cmsg29") }}
      </v-alert>
      <v-alert
        outlined
        color="red"
        v-if="list._id && list.status == 'rejected'"
      >
        <div class="font-weight-bold mb-2">{{ $t("1id") }}</div>
        <div v-html="list.admin_msg"></div>
      </v-alert>
      <v-row v-if="!list._id || list.status == 'rejected'">
        <v-col cols="12" md="6"
          ><v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="submit"
          >
            <v-alert dense outlined type="error" v-if="error">
              <ul>
                <li v-for="item in error" :key="item.msg">
                  {{ $t(item.msg) }}
                </li>
              </ul>
            </v-alert>
            <div>
              <h1 class="text-h5 mb-5">
                {{ $t("Confirmyouridentity") }}
              </h1>
            </div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  outlined
                  type="text"
                  v-model="list.legalName"
                  :rules="reqRules"
                  v-bind:label="$t('LegalFullName')"
                ></v-text-field>
                <vue-tel-input-vuetify
                  outlined
                  v-bind:label="$t('PhoneNumber')"
                  :rules="phoneRules"
                  v-model="list.phone"
                  aria-autocomplete=""
                  placeholder=""
                  mode="international"
                  defaultCountry="US"
                  :preferredCountries="['US', 'JP']"
                  dense
                ></vue-tel-input-vuetify>
                <v-text-field
                  dense
                  outlined
                  type="text"
                  v-model="list.phone_interview_time"
                  :rules="reqRules"
                  v-bind:label="$t('availabletotalk')"
                  v-bind:hint="$t('availabletotalkhint')"
                  persistent-hint
                  class="mb-5"
                ></v-text-field>
                <v-radio-group v-model="list.identityType">
                  <div class="overline">
                    {{ $t("ChooseanIDtype") }}
                  </div>
                  <v-radio
                    v-for="(item, i) in identityTypeArray"
                    :key="i"
                    :value="item"
                    :rules="reqRules"
                    v-bind:label="$t(item)"
                  >
                  </v-radio>
                </v-radio-group>
                <v-form ref="form" lazy-validation v-if="!list.fileFrontImg">
                  <v-file-input
                    v-if="
                      list.identityType != 'verifiedinairbnb' &&
                        list.identityType != 'verificationcode'
                    "
                    type="file"
                    v-model="fileFront"
                    show-size
                    v-bind:label="$t('ClickHereSelectFrontImage')"
                    :rules="reqRules"
                    accept="image/png, image/jpeg, image/bmp"
                    outlined
                    dense
                    @change="handleFrontImage"
                    prepend-icon="mdi-camera"
                  ></v-file-input>
                </v-form>
                <v-alert outlined dense type="info" v-if="list.fileFrontImg">
                  {{ $t("FrontImageRes") }}
                </v-alert>
                <v-form ref="form" lazy-validation v-if="!list.fileBackImg">
                  <v-file-input
                    v-if="
                      list.identityType != 'verifiedinairbnb' &&
                        list.identityType != 'verificationcode'
                    "
                    type="file"
                    v-model="fileBack"
                    show-size
                    v-bind:label="$t('ClickHereSelectBackImage')"
                    accept="image/png, image/jpeg, image/bmp"
                    outlined
                    dense
                    @change="handleBackImage"
                    prepend-icon="mdi-camera"
                  ></v-file-input>
                </v-form>
                <v-alert outlined dense type="info" v-if="list.fileBackImg">
                  {{ $t("BackImageRes") }}
                </v-alert>
                <v-text-field
                  v-if="list.identityType == 'verifiedinairbnb'"
                  dense
                  outlined
                  type="text"
                  v-model="list.airbnbId"
                  :rules="reqRules"
                  v-bind:label="$t('AirBnBusername')"
                  v-bind:hint="$t('AirBnBusernamehint')"
                  persistent-hint
                  class="mb-5"
                ></v-text-field>
                <v-text-field
                  v-if="list.identityType == 'verificationcode'"
                  dense
                  outlined
                  type="text"
                  v-model="list.verificationCode"
                  :rules="reqRules"
                  v-bind:label="$t('verificationcodelabel')"
                  v-bind:hint="$t('verificationcodehind')"
                  persistent-hint
                  class="mb-5"
                ></v-text-field>
                <v-btn
                  large
                  color="light-blue"
                  dark
                  block
                  rounded
                  type="submit"
                >
                  <span class="mr-2">{{ $t("Submit") }}</span>
                  <v-icon size="small">mdi-arrow-right-thick</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-btn
              class="mt-5"
              large
              color="light-blue"
              dark
              block
              rounded
              outlined
              to="/"
            >
              <span>{{ $t("dolater") }}</span>
            </v-btn>
          </v-form>
        </v-col>
        <v-col cols="12" md="6">
          <v-alert dense type="info" outlined class="ml-md-10">
            {{ $t("Cmsg23") }}
          </v-alert>
          <v-alert class="ml-md-10" type="info" outlined color="black">
            {{ $t("Cmsg21") }} <br /><br />
            {{ $t("Cmsg22") }}
          </v-alert>
        </v-col>
      </v-row>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-container>
  </div>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import AuthService from "@/services/AuthService";
import defaultJson from "@/assets/default.json";
import swal from "sweetalert";

export default {
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  name: "ConfirmIdentityComponent",
  data() {
    return {
      list: {
        legalName: null,
        identityType: "passport",
        fileFrontImg: "",
        fileBackImg: "",
        phone: "",
        phone_interview_time: "",
        airbnbId: "",
        verificationCode: ""
      },
      fileFront: null,
      loading: true,
      fileBack: null,
      waitDialog: false,
      error: null,
      valid: null,
      identityTypeArray: defaultJson.identityType,
      reqRules: [value => !!value || this.$t("string719")],
      phoneRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /[A-Za-z]+/;
          return !pattern.test(value) || this.$t("string722");
        },
        value =>
          (value.length >= 7 && value.length <= 18) || this.$t("string723")
      ]
    };
  },
  created() {
    var token = this.$store.state.token;
    AuthService.getConfirmIdentity({
      headers: { Authorization: "Bearer " + token }
    })
      .then(result => {
        if (result.data.item) {
          this.list = result.data.item;
        }
        if (result.data.phone) {
          this.list.phone = result.data.phone;
        }
        if (result.data.airbnbId) {
          this.list.airbnbId = result.data.airbnbId;
        }
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async handleFrontImage() {
      if (this.fileFront) {
        this.waitDialog = true;
        let formData = new FormData();
        formData.append("file", this.fileFront);
        await AuthService.uploadIdentityFile(formData)
          .then(result => {
            this.list.fileFrontImg = result.data.location;
            setTimeout(() => (this.waitDialog = false), 500);
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    async handleBackImage() {
      if (this.fileBack) {
        this.waitDialog = true;
        let formData = new FormData();
        formData.append("file", this.fileBack);
        await AuthService.uploadIdentityFile(formData)
          .then(result => {
            this.list.fileBackImg = result.data.location;
            setTimeout(() => (this.waitDialog = false), 500);
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        await AuthService.confirmIdentity(this.list)
          .then(() => {
            this.waitDialog = false;
            this.$router.push({ name: "Dashboard" });
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    inquireVerification() {
      AuthService.inquireIdentity({ id: this.list._id })
        .then(() => {
          this.waitDialog = false;
          swal({
            icon: "success",
            text: this.$t("string695"),
            button: {
              text: this.$t("Close"),
              className: "swal-close"
            }
          });
        })
        .catch(err => {
          this.error = err.response.data.errors;
          setTimeout(() => (this.waitDialog = false), 500);
        });
    }
  }
};
</script>

<style></style>
